import { render } from "./cpplfb.vue?vue&type=template&id=cdeda01c&scoped=true"
import script from "./cpplfb.vue?vue&type=script&lang=js"
export * from "./cpplfb.vue?vue&type=script&lang=js"

import "./cpplfb.vue?vue&type=style&index=0&id=cdeda01c&scoped=true&lang=scss"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdeda01c"]])

export default __exports__